<template>
	<div class="menus">
		<div>
			<b-card no-body>
				<b-tabs pills card vertical>
					<b-tab title="Consultar menus" active>
            <list-menus></list-menus>
					</b-tab>
					<b-tab title="Adicionar menu">
            <new-menu></new-menu>
					</b-tab>
					<b-tab title="Consultar refeiçoes">
            <list-meals></list-meals>
					</b-tab>
					<b-tab title="Adicionar refeiçoes">
            <new-meal></new-meal>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>

<script>
import newMenu from '../components/Menus/newMenu.vue'
import newMeal from '../components/Menus/newMeal.vue'
import listMenus from '../components/Menus/listMenus.vue'
import listMeals from '../components/Menus/listMeals.vue'
export default {
	name: "menus",
	data() {
		return {
		}
	},
	components: {
    newMenu,
    newMeal,
    listMenus,
    listMeals
	}
}
</script>

<style lang='css'>
.menus {
	color: #53574D;
}
.menus a {
  color: #53574D !important;
}
</style>

